<template>
  <layout-main>
    <div class="container">
      <div class="content">
        <md-card>
          <md-card-header>
            <div class="md-title">パスワード変更</div>
          </md-card-header>
          <md-card-content>
            <md-field :class="{'md-invalid': newPasswordInvalid}">
              <label>新しいパスワード</label>
              <md-input type="password" v-model="newPassword"></md-input>
              <span class="md-error">{{ newPasswordInvalidMessage }}</span>
            </md-field>
            <md-field :class="{'md-invalid': newPasswordConfirmInvalid}">
              <label>新しいパスワード（確認）</label>
              <md-input type="password" v-model="newPasswordConfirm"></md-input>
              <span class="md-error">{{ newPasswordConfirmInvalidMessage }}</span>
            </md-field>
            <div class="error">{{ errorMessage }}</div>
          </md-card-content>
          <md-card-actions md-alignment="space-between">
            <md-button class="md-raised md-primary" @click="changePassword">変更</md-button>
          </md-card-actions>
        </md-card>
      </div>

      <md-snackbar
        md-position="center"
        :md-duration="snackbar.duration"
        :md-active.sync="snackbar.show"
        md-persistent
      >
        <span>変更しました</span>
      </md-snackbar>
    </div>
  </layout-main>
</template>

<script>
import LayoutMain from '@/components/layout/LayoutMain'

const PASSWORD_MIN_LENGTH = 8
const PASSWORD_EMPTY_MESSAGE = '入力してください'
const PASSWORD_LENGTH_MESSAGE = '8文字以上入力してください'

function validateNewPassword(v) {
  if (!v) {
    return PASSWORD_EMPTY_MESSAGE
  }
  if (v.length < PASSWORD_MIN_LENGTH) {
    return PASSWORD_LENGTH_MESSAGE
  }
}

export default {
  components: { LayoutMain },
  name: 'Preferences',
  data() {
    return {
      newPassword: '',
      newPasswordConfirm: '',
      newPasswordInvalid: false,
      newPasswordInvalidMessage: '',
      newPasswordConfirmInvalid: false,
      newPasswordConfirmInvalidMessage: '',
      errorMessage: '',
      snackbar: {
        show: false,
        duration: 1500,
      },
    }
  },
  methods: {
    async changePassword() {
      // clear errors
      this.newPasswordInvalid = false
      this.newPasswordInvalidMessage = ''
      this.newPasswordConfirmInvalid = false
      this.newPasswordConfirmInvalidMessage = ''

      let errMessage

      errMessage = validateNewPassword(this.newPassword)
      if (errMessage) {
        this.newPasswordInvalid = true
        this.newPasswordInvalidMessage = errMessage
      }

      errMessage = validateNewPassword(this.newPasswordConfirm)
      if (errMessage) {
        this.newPasswordConfirmInvalid = true
        this.newPasswordConfirmInvalidMessage = errMessage
      }

      if (this.newPasswordInvalid || this.newPasswordConfirmInvalid) {
        // この時点でエラーがある場合には続行不要
        return
      }

      if (this.newPassword !== this.newPasswordConfirm) {
        this.errorMessage = 'パスワードが一致しません'
        return
      }

      await this.$account.changePassword(
        this.$store.state.user.companyCode,
        this.$store.state.user.loginId,
        this.newPassword,
      )

      // 初期パスワードの変更を行って成功しているので、
      // トークンを取得し直してトップに移動する。
      // 勝手にパスワード使っちゃってるけどいいんだろうか、、、
      await this.$store.dispatch('login', {
        companyCode: this.$store.state.user.companyCode,
        loginId: this.$store.state.user.loginId,
        password: this.newPassword,
      })

      this.newPassword = undefined
      this.newPasswordConfirm = undefined

      this.snackbar.message = ''
      this.snackbar.show = true
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.content {
  width: 500px;
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>
